// (PRACTICE_TEST_DATA:any) => {
export const preambleBySection = (PRACTICE_TEST_DATA:any, lang:string, sectionIndex:number) => {
    const preambles = PRACTICE_TEST_DATA['PREAMBLES_'+lang.toUpperCase()];
    if (preambles){
        return preambles[sectionIndex];
    }
}